// translations/pages/team/it.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageIT = {
  hero: {
    title: 'Team',
    intro: 'Adrian Eisenmeier e Nikolai Genov hanno fondato pAIoneer Labs GmbH e la dirigono come amministratori delegati.',
    members: 'Adrian Eisenmeier è fisico (Dipl.-Phys.) e sviluppa sistemi là dove si incontrano IA, architettura software, protezione dei dati e sicurezza. Nikolai Genov è dottore di ricerca in bioinformatica e responsabile tecnico per lo sviluppo software assistito dall’IA e l’analisi dei dati in contesti regolamentati della sanità, delle scienze della vita e della finanza. Alina Tselinina è sviluppatrice software e data engineer con una laurea magistrale in matematica finanziaria e attuariale e sviluppa applicazioni, API REST e pipeline di dati in Python e R.'
  },
  card: {
    cta: 'Visualizza il profilo'
  },
  profile: {
    overview: 'Team',
    membersLabel: 'Membri del team'
  }
};
